import React from 'react';
import { Phone, Wrench, CheckCircle, Award, Zap } from 'lucide-react';
export function DieselEngineRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4800">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4801">
        <div className="container mx-auto px-4" data-id="element-4802">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4803">
            Diesel Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center italic" data-id="element-4804">
            Serving Farmington Hills, Farmington, Novi, Livonia, Northville
            Since 1958
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4805">
        <div className="max-w-4xl mx-auto" data-id="element-4806">
          {/* Genuine Parts */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4807">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-4808">
              We Use Genuine Ford Powerstroke and Chevy Duramax Parts
            </h2>
            <p className="text-gray-700 text-center" data-id="element-4809">
              whenever possible and when a better compatible part isn't
              available at a fair price.
            </p>
          </div>

          {/* Services Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4810">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-4811">
              <div data-id="element-4812">
                <ul className="space-y-3" data-id="element-4813">
                  <li className="flex items-start" data-id="element-4814">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4815" />
                    <span className="text-gray-700" data-id="element-4816">
                      <strong data-id="element-4817">
                        Major and Minor Diesel Engine Repairs on all Makes and
                        Models
                      </strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4818">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4819" />
                    <span className="text-gray-700" data-id="element-4820">
                      <strong data-id="element-4821">Diesel Engine Overhauls</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4822">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4823" />
                    <span className="text-gray-700" data-id="element-4824">
                      <strong data-id="element-4825">Tune-ups for Diesel Engines</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4826">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4827" />
                    <span className="text-gray-700" data-id="element-4828">
                      <strong data-id="element-4829">State-of-The-Art Computer Diagnostics</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4830">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4831" />
                    <span className="text-gray-700" data-id="element-4832">
                      <strong data-id="element-4833">Air Systems and Fuel Systems</strong>
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-4834">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4835" />
                    <span className="text-gray-700" data-id="element-4836">
                      <strong data-id="element-4837">Preventive Maintenance Services</strong>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="flex justify-center items-center" data-id="element-4838">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/jrbus%202.JPG300x300.jpg?opt=w3" alt="Diesel engine repair" className="max-w-[300px] h-auto rounded-lg shadow-md" data-id="element-4839" />
              </div>
            </div>
          </div>

          {/* Ford Powerstroke Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4840">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4841">
              Ford Powerstroke Diesel Engine Repair
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-4842">
              We're Ford Diesel Engine Experts: Our Licensed and Certified
              Diesel Engine Mechanics provide all aspects of Powerstroke Diesel
              Engine Diagnostics, Maintenance and Repair. Having decades of
              experience in diesel engine repair applied to every job saves you
              time, money, and in many cases, a severe headache. The Ford
              Powerstroke Engine line is a powerful horsepower plant, capable of
              reliably hauling heavy loads for hundreds of thousands of miles.
              Keeping these diesel engines operating properly is imperative to
              your bottom line.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4843">
              <p className="text-gray-800 font-bold text-center text-lg" data-id="element-4844">
                We Sell and Use Only Genuine Ford Powerstroke Parts or Parts
                Compatible with Ford Powerstroke Engines.
              </p>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4845">
              Our Licensed and Certified Diesel Engine Mechanics Perform All
              Aspects of Service on Ford Powerstroke Diesel Engines:
            </h3>

            <ul className="space-y-3 mb-6" data-id="element-4846">
              <li className="flex items-start" data-id="element-4847">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4848" />
                <span className="text-gray-700" data-id="element-4849">
                  Routine Maintenance and Preventive Service
                </span>
              </li>
              <li className="flex items-start" data-id="element-4850">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4851" />
                <span className="text-gray-700" data-id="element-4852">
                  Ford Powerstroke Diesel Engine Diagnostics
                </span>
              </li>
              <li className="flex items-start" data-id="element-4853">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4854" />
                <span className="text-gray-700" data-id="element-4855">
                  Ford Powerstroke Diesel Engine Fuel System Diagnostics and
                  Repairs
                </span>
              </li>
              <li className="flex items-start" data-id="element-4856">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4857" />
                <span className="text-gray-700" data-id="element-4858">
                  Powerstroke Diesel Engine Injector Diagnostics and Injector
                  Replacement
                </span>
              </li>
              <li className="flex items-start" data-id="element-4859">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4860" />
                <span className="text-gray-700" data-id="element-4861">
                  DEF System Diagnostics, Maintenance and Repairs
                </span>
              </li>
              <li className="flex items-start" data-id="element-4862">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4863" />
                <span className="text-gray-700" data-id="element-4864">
                  Powerstroke Diesel Engine Oil Change
                </span>
              </li>
              <li className="flex items-start" data-id="element-4865">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4866" />
                <span className="text-gray-700" data-id="element-4867">
                  Powerstroke Diesel Engine Filter Changes
                </span>
              </li>
            </ul>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6" data-id="element-4868">
              <p className="text-gray-700" data-id="element-4869">
                Ford Diesel Fuel Injectors will begin needing replacement often
                at around 120,000 miles. Due to the poor fuel that is common
                today, its super low sulfur content reduces lubrication and
                increases wear and tear on these injectors. The Ford replacement
                injectors are okay, but there are better injectors available
                which we normally use when installing new diesel fuel injectors
                into a Ford Powerstroke Diesel Engine. This has a little
                increase in expense, but they last much longer, are more
                reliable and make your diesel engine more efficient - that saves
                you more than the slight increase in installing the better
                diesel fuel injectors.
              </p>
            </div>
          </div>

          {/* Chevy Duramax Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4870">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4871">
              Chevy Duramax Diesel Engine Repair
            </h2>

            <p className="text-center text-lg font-semibold text-gray-800 mb-4" data-id="element-4872">
              Our Service uses Genuine Chevy Duramax Diesel Parts where possible
              and when better compatible parts are not available.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-4873">
              Duramax Diesel Engine Repairs Performed By Licensed and Certified
              Diesel Engine Mechanics
            </h3>

            <p className="text-gray-700 mb-6" data-id="element-4874">
              Duramax Diesel Engines are reliable and powerful, but just like
              all engines they need proper maintenance and repairs or severe
              damage may occur.
            </p>

            <p className="text-gray-700 mb-6" data-id="element-4875">
              Our licensed and certified diesel mechanics are experienced with
              Chevy Duramax Diesel Engines. Whether you need routine
              maintenance, such as oil and filter changes or glow plug
              replacement, fuel injector replacement, or a complete Duramax
              Engine Rebuild, we are your Diesel Engine Mechanic Shop.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-4876">
              Duramax Diesel Engines We Work On:
            </h3>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-4877">
              <ul className="space-y-2 text-gray-700" data-id="element-4878">
                <li className="text-center" data-id="element-4879">
                  Duramax LB7 (2001-2004 Chevrolet Silverado HD and GMC Sierra
                  HD)
                </li>
                <li className="text-center" data-id="element-4880">Duramax LLY (2004.5-2005)</li>
                <li className="text-center" data-id="element-4881">Duramax LBZ (2006-2007)</li>
                <li className="text-center" data-id="element-4882">Duramax LMM (2008-2010)</li>
                <li className="text-center" data-id="element-4883">Duramax LML (2011-2016)</li>
                <li className="text-center" data-id="element-4884">
                  Duramax LGH (2011-2016 Chevrolet Express and GMC Savana)
                </li>
                <li className="text-center" data-id="element-4885">Duramax L5P (2017-)</li>
              </ul>
            </div>
          </div>

          {/* 7.3L Powerstroke History */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4886">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-4887">
              History of the 7.3 liter International Engine
            </h2>

            <div className="flex justify-center mb-6" data-id="element-4888">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3%20ps.jpg200x200.jpg?opt=w3" alt="7.3 Powerstroke engine" className="max-w-[305px] h-auto rounded-lg shadow-md" data-id="element-4889" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4890">
              7.3 Powerstroke
            </h3>

            <div className="space-y-4 text-gray-700" data-id="element-4891">
              <p data-id="element-4892">
                The first 7.3L was produced from 1988-1993. The original 7.3L
                diesel was a non-turbo charged indirect injection (IDI) engine,
                followed shortly after by a turbo charged version. It was very
                similar to the previous 6.9l IDI diesel engine, which was simply
                bored out for more torque. This engine is not considered in the
                powerstroke family. In 1994, the 7.3L underwent some changes.
                The 7.3L was changed to a direct injection (DI) engine from the
                original IDI engine.
              </p>

              <p data-id="element-4893">
                Ford also added electronic fuel injectors and gave it the name
                Power Stroke. This model produced up to 250 hp (190 kW) and 525
                lb·ft (712 N·m) of torque. The new 7.3L DI Power stroke had
                "single shot" HEUI (hydraulic electronic unit injectors) fuel
                injectors and ran a 15º high pressure oil pump (HPOP) to create
                fuel injection pressures. The turbine housing was a 1.15 A/R. In
                1999, an air to air intercooler was added. The intercooler
                cooled the charged air from the turbo making it denser. The
                cooler, denser air would increase the horsepower potential of
                the engine, while also reducing exhaust gas temperatures (EGTs).
                The turbine housing was changed to a .84 A/R housing and a
                wastegate was added.
              </p>

              <p data-id="element-4894">
                The "single shot" HEUI injectors were upgraded to "split shot"
                injectors. With larger injectors, the HPOP was advanced to 17º
                to increase fuel pressures. The 7.3L DI Power Stroke was in
                production up until 2004 when it was replaced by the 6.0L. The
                7.3 IDI and 7.3 Powerstroke are not the same engine at all
                except manufactured by International for Ford. This is known to
                be the longest lasting and most reliable powerstroke engine.
              </p>
            </div>

            <div className="bg-red-50 border-2 border-[#B1050B] rounded-lg p-6 mt-6 text-center" data-id="element-4895">
              <p className="text-2xl font-bold text-[#B1050B]" data-id="element-4896">
                We Are Powerstroke Experts
              </p>
            </div>
          </div>

          {/* Second Generation Powerstroke */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4897">
            <div className="flex justify-center mb-6" data-id="element-4898">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/0810dp_05_z+ford_power_stroke_diesel+second_generation_power_stroke.jpg300x300.jpg?opt=w3" alt="Second generation Powerstroke" className="max-w-[300px] h-auto rounded-lg shadow-md" data-id="element-4899" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4900">
              Hydraulically Actuated Electronically Controlled Unit Injector
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-4901">
              The new HEUI Fuel systems on the Power Stroke required the use of
              two oil pumps. A low-pressure (lubricating) pump feeds oil into
              the high-pressure oil reservoir, where the high-pressure oil pump
              (HPOP) forces oil through oil lines to two high-pressure oil
              rails, one located in each cylinder head at an injection oil
              pressure of 500-3,000 psi. The pressure is controlled
              electronically by a regulator located inside the pump. Basically,
              all of this culminates in a unique system where the oil increases
              the fuel pressure at the injectors.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4902">
              Second-Generation Power Stroke
            </h3>
            <p className="text-gray-700" data-id="element-4903">
              The second generation of 7.3L began with the '99 model year. This
              version of the Power Stroke was intercooled (termed charge air
              cooling or CAC), fittingly for trucks labeled "Super Duty," and
              put out more horsepower and torque. First-year Super Dutys and '00
              engines put out 235 hp and 500 lb-ft of torque. Although '99 and
              '00 models shared the same engine, '99s can be spotted by their
              "Power Stroke V-8" badge that is visible in front of the truck's
              front fender-wells. Power Stroke badges built in 2000 or later are
              displayed on the bottom of each truck's door panels.
            </p>
          </div>

          {/* Generation Link */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-4904">
            <p className="text-[#B1050B] font-bold mb-4" data-id="element-4905">
              What Generation Engine is in my Truck? Click below to find out
            </p>
            <a href="/services/ford-7-3l-gas" className="inline-block bg-[#B1050B] hover:bg-[#8A0408] text-white px-6 py-3 rounded-lg font-bold text-lg transition-colors" data-id="element-4906">
              7.3l Power Stroke 1st Generation or Second Generation
            </a>
          </div>

          {/* How Diesel Engines Work */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4907">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-4908">
              How diesel engines work
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-4909">
              When gas is compressed its temperature rises. A diesel engine
              exploits this property in order to ignite the fuel. Air is drawn
              into the cylinder of a diesel engine, and compressed by the rising
              piston. This happens at a much higher compression rate than in a
              spark-ignition engine. At the top of the piston stroke diesel fuel
              is injected into the combustion chamber at high pressure through
              an atomising nozzle. It mixes with the hot, pressurised air. The
              resulting mixture ignites and burns very rapidly. This contained
              explosion causes the gas in the chamber to expand, driving the
              piston down with considerable force, and creating power in a
              vertical direction.
            </p>

            <div className="space-y-4" data-id="element-4910">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4911">
                <p className="text-gray-700" data-id="element-4912">
                  A gasoline engine intakes a mixture of gas and air, compresses
                  it and ignites the mixture with a spark. A diesel engine takes
                  in just air, compresses it and then injects fuel into the
                  compressed air. The heat of the compressed air lights the fuel
                  spontaneously.
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4913">
                <p className="text-gray-700" data-id="element-4914">
                  A gasoline engine compresses at a ratio of 8:1 to 12:1, while
                  a diesel engine compresses at a ratio of 14:1 to as high as
                  25:1. The higher compression ratio of the diesel engine leads
                  to better efficiency.
                </p>
              </div>
            </div>
          </div>

          {/* Fuel Delivery Systems */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4915">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4916">
              Fuel Delivery Systems
            </h3>

            <p className="text-gray-700 mb-4" data-id="element-4917">
              Gasoline engines use either a carburetor or a fuel injection
              system to deliver the fuel to the cylinder. With a carburetor the
              fuel is mixed as it enters the intake manifold, long before it
              gets to the cylinders. In a fuel injection system the fuel is
              injected just before the intake stroke at the intake valve.
            </p>

            <p className="text-gray-700" data-id="element-4918">
              Diesel engines use direct fuel injection (DI), that is to say the
              diesel fuel is injected directly into the cylinder. The diesel
              engine has no spark plugs. The air it takes in is compressed and
              the fuel is injected directly into the cylinder where the heat
              caused by the air compression ignites the fuel. In the old days
              this meant that it exploded and expanded very quickly, making a
              noisy engine. This is why most diesel cars were IDI (indirect
              injection); the rough behavior was fixed by injecting the fuel
              into a small pre-combustion chamber that is connected to the
              cylinder by a narrow passage.
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4919">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4920">
              Need Diesel Engine Service?
            </h2>
            <p className="text-xl mb-6" data-id="element-4921">
              <strong data-id="element-4922">If We can Help Give us a Call</strong>
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4923">
              <Phone className="mr-3" size={24} data-id="element-4924" />
              Call 248-478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4925">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}